import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'diagnostico', pathMatch: 'full' },
  {
    path: 'diagnostico',
    loadComponent: () => import('./pages/diagnostico/diagnostico.component').then((m) => m.DiagnosticoComponent)
  },
  {
    path: 'intervencao',
    loadComponent: () => import('./pages/intervencao/intervencao.component').then((m) => m.IntervencaoComponent)
  },
  {
    path: 'monitoramento',
    loadComponent: () => import('./pages/monitoramento/monitoramento.component').then((m) => m.MonitoramentoComponent)
  },
  {
    path: 'ajuste',
    loadComponent: () => import('./pages/ajuste/ajuste.component').then((m) => m.AjusteComponent)
  },
  {
    path: 'integracao',
    loadComponent: () => import('./pages/integracao/integracao.component').then((m) => m.IntegracaoComponent)
  },
  {
    path: 'sustentacao',
    loadComponent: () => import('./pages/sustentacao/sustentacao.component').then((m) => m.SustentacaoComponent)
  },
  { path: '**', redirectTo: 'diagnostico' }
];
